export const config = (
  translations,
  placeNameList,
  municipalityNameList,
  requestForSignetApprovalStatus,
  isAuthorizedPersonLoggedIn,
  enums
) => {
  const { referenceNumber, createdAtFrom, createdAtTo, status } =
    translations || {};
  const { Status } = enums || {};

  return {
    fields: [
      {
        key: 1,
        name: 'kjs.name',
        type: 'text',
        label: 'kjs.name',
        component: 'input',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 2,
        name: 'kjs.uniqueNumber',
        type: 'text',
        label: 'kjs.uniqueNumber',
        component: 'input',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 3,
        name: 'referenceNumber',
        type: 'text',
        label: referenceNumber,
        component: 'input',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 4,
        name: 'kjs.pib',
        type: 'text',
        label: 'kjs.pib',
        component: 'input',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 5,
        name: 'createdAtFrom',
        type: 'date',
        label: createdAtFrom,
      },
      {
        key: 6,
        name: 'createdAtTo',
        type: 'date',
        label: createdAtTo,
      },
      {
        key: 7,
        name: 'place.name',
        type: 'autocomplete',
        label: 'place.name',
        optionList: placeNameList || [],
        getOptionLabel: (placeName) => placeName || '',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 8,
        name: 'municipality.name',
        type: 'autocomplete',
        label: 'municipality.name',
        optionList: municipalityNameList || [],
        getOptionLabel: (municipalityName) => municipalityName || '',
        notVisible: isAuthorizedPersonLoggedIn,
      },
      {
        key: 8,
        name: 'status',
        type: 'autocomplete',
        label: status,
        optionList: requestForSignetApprovalStatus || [],
        getOptionLabel: (s) => Status[s.constant]?.text || '',
      },
    ],
  };
};
